import "reflect-metadata";

export function ColumnTitle(title: string) {
    return Reflect.metadata("column-title", title);
}
